import React from 'react';
import { useField } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import { CampaignFormView } from '../../CampaignFormItem';
import { DiscountedItemCountInput } from '../../discounted-item-count-section/DiscountedItemCountInput';

type DiscountedItemCountSelectorProps = {
  disabled: boolean;
};

const DEFAULT_ITEM_TRIGGER_COUNT = 1;
export const DISCOUNTED_ITEM_COUNT_OPTIONS = [1, 2, 3, 4];

export const DiscountedItemCountSelector = ({ disabled }: DiscountedItemCountSelectorProps) => {
  const freeItemsField = useField<number | undefined>('freeItemsCount');

  return (
    <CampaignFormView
      title={<FormattedMessage id="campaigns.form.item-count.how-many" />}
      value={
        <DiscountedItemCountInput
          disabled={disabled}
          name="itemTriggerCount"
          defaultValue={DEFAULT_ITEM_TRIGGER_COUNT}
          onChange={() => {
            // Reset the free items count to 1 when itemTriggerCount changes
            freeItemsField.input.onChange(1);
          }}
          messageId="campaigns.form.item-count.item"
        />
      }
    ></CampaignFormView>
  );
};
